import { RequestStatus } from "mobx-store";

export interface IStaticTextStore {
  staticTextsList: StaticText[];
  selectedStaticText: StaticText;
  loading: boolean;
  getStaticTextsRequestStatus: RequestStatus;

  getStaticTexts(app: STATIC_TEXT_APP, options: GetStaticTextsOptions, languageCode?: string): Promise<void>;

  getStaticTextByKey(key: string, app: STATIC_TEXT_APP, languageCode?: string): Promise<void> ;

  createStaticText(newStaticText: StaticText, languageCode?: string): Promise<StaticText>;

  updateStaticText(updatedStaticText: any, key: string, app: STATIC_TEXT_APP, languageCode?: string): Promise<any>;
}

export const staticTextConstants = { unCategorized : 'Un Categorized' };

export enum STATIC_TEXT_APP {
  MOBILE = 'mobile',
  PORTAL = 'portal'
};

export interface GetStaticTextsOptions {
  category?: string;
  keys?: StaticTextStatus;
}

export enum StaticTextStatus {
  NEW = "new",
  OLD = "old",
  ALL = "all"
};
export class StaticText {

  key: string;
  description: string;
  value: string;
  category: string;
  app: STATIC_TEXT_APP;

  constructor() {
    this.description = '';
    this.value = '';
    this.key = '';
    this.category = '';
    this.app = STATIC_TEXT_APP.MOBILE;
  }

  setDescription(newDescription: string): void {
    this.description = newDescription;
  }

  getDescription(): string {
    return this.description;
  }

  setKey(newKey: string): void {
    this.key = newKey;
  }

  getKey(): string {
    return this.key;
  }

  setValue(newValue: string): void {
    this.value = newValue;
  }

  getValue(): string {
    return this.value;
  }

  getCategory(): string {
    return this.category;
  }

  setCategory(category: string): void {
    this.category = category ? category : staticTextConstants.unCategorized;
  }

  setApp(app: STATIC_TEXT_APP): void {
    this.app = app;
  }

}
